import React, {Component} from 'react';

import logoINE from '../img/logoINE_blanco.svg';
import logoSIJE from '../img/sijeLogo_PEL2020.svg';
import VinculosFooter from './VinculosFooter';

class Pie extends Component {
    render() {
      return (
        <div className="footer">
            <VinculosFooter />
            <div className="container pie">
                <div className="col-md-12">
                    <div className="legal">
                        <p className="centrar">Los materiales mostrados se refieren al Sistema de Información de la Jornada Electoral del Proceso Electoral 2021, los cuales son informativos y sin efectos jurídicos. Alterar la información y/o el contenido total o parcial de este sitio es delito federal.</p>
                    </div>
                </div>
            </div>
            <div className="pieNegro">
                <div className="container">
                    <div className="logosPie">
                        <img src={logoINE} alt="Logo INE"></img>
                        <img src={logoSIJE} alt="Logo SIJE" className="imgBlanca"></img>
                    </div>
                    <small>© 2021 Instituto Nacional Electoral | Todos los derechos reservados <span>v 0.005</span></small>
                </div>
            </div>
        </div>
      );
    }
  }

export default Pie;